import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { products } from "../data/products";
import { Helmet } from "react-helmet-async";
import ContactForm from "../components/ContactForm";
import ContactModal from "../components/ContactModal";
import CustomerSay from "../components/CustomerSay";
import FAQSchema from "../components/FAQSchema";

const ProductInternal = () => {
  const { slug } = useParams();
  const product = products.find((p) => p.slug === slug);

  
  useEffect(() => {
    let swiperInstance;


    if (
      typeof window !== "undefined" &&
      window.Swiper &&
      document.querySelector(".customerslide")
    ) {
      swiperInstance = new window.Swiper(".customerslide", {
        loop: true,
        slidesPerView: 1,
        navigation: {
          nextEl: ".testi-button-next",
          prevEl: ".testi-button-prev",
        },
        pagination: {
          el: ".swiper-paginationnn",
          clickable: true,
        },
        breakpoints: {
          768: {
            slidesPerView: 3,
            spaceBetween: 30,
           slidesPerGroup: 3,
          },
        },
      });
    }
    return () => {
      if (swiperInstance && typeof swiperInstance.destroy === "function") {
        swiperInstance.destroy(true, true);
      }
    };
  }, [slug]); // slug change pe re-init


  if (!product) return <p>Product not found</p>;

  return (
    <>
      <Helmet>
        <title>{product.meta.title}</title>
        <meta name="description" content={product.meta.description} />
        <meta name="keywords" content={product.meta.keywords} />
      </Helmet>
      <FAQSchema faqs={product.content.faq} />

       <ContactModal />

      {/* Banner Section */}
      <section>
        <div className="swiper animeslide productintermbr">
          <div className="swiper-wrapper">
            <div
              className="swiper-slide animeslide-slide slide1"
              style={{ backgroundImage: `url(${product.content.banner.bg})` }}
            >
              <div className="container">
                <div className="row">
                  <div className="col-sm-6 banner_content">
                    <div className="content-slide">
                      <div data-animate="bottom" className="animeslide-heading">
                        <h1>{product.content.banner.heading}</h1>
                        <p>{product.content.banner.text}</p>
                      </div>
                      <div data-animate="bottom" className="animeslide-desc">
                        <a href="#" data-bs-toggle="modal" data-bs-target="#staticBackdrop">
                          <span>Let’s Get Started</span>
                          <img src={product.content.banner.Iconbtn} alt="" />
                        </a>
                      </div>
                    </div>
                  </div>
                  <div
                    className="col-sm-6"
                    style={{ display: "flex", alignItems: "flex-end" }}
                  >
                    <img
                      src={product.content.banner.img}
                      alt={product.content.banner.alt}
                      style={{ width: "100%" }}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Ambience Section */}
      <section className="ambience_and_harmony_section tailored">
        <div className="container">
          <div className="row about_the_studio about_product ">
            <div className="col-sm-6">
              <div className="ambience_content">
                <div className="brands_content the_studio product_content product_internal_content">
                  <h2>{product.content.ambience.heading}</h2>
                  <p>{product.content.ambience.text}</p>
                </div>
              </div>
            </div>
            <div className="col-sm-5">
              <div className="ambience_imgs">
                <img src={product.content.ambience.img} alt={product.content.ambience.alt} />
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* industries_we_dress Section */}
      {slug === "industrial" && (
        <>
          <section className="brands_section industries_we_dress">
            <div className="brands_content pro_content">
              <h2>{product.content.industries.heading}</h2>
              <p>{product.content.industries.text}</p>
            </div>
            <div className="industries_we_dress_with_purpose">
              <div className="container">
                <div className="row ">
                  <div className="col-sm-7">
                    <div className="row first_row">
                      <div className="col-sm-6">
                        <div
                          className="inds_3"
                          style={{
                            backgroundImage: `url(${product.content.industries.img1})`,
                          }}
                        >
                          <h3>{product.content.industries.title1}</h3>
                        </div>
                      </div>
                      <div className="col-sm-6">
                        <div
                          className="inds_3"
                          style={{
                            backgroundImage: `url(${product.content.industries.img2})`,
                          }}
                        >
                          <h3>{product.content.industries.title2}</h3>
                        </div>
                      </div>
                    </div>
                    <div className="row">
                      <div className="col-sm-6">
                        <div
                          className="inds_3"
                          style={{
                            backgroundImage: `url(${product.content.industries.img3})`,
                          }}
                        >
                          <h3>{product.content.industries.title3}</h3>
                        </div>
                      </div>
                      <div className="col-sm-6">
                        <div
                          className="inds_3"
                          style={{
                            backgroundImage: `url(${product.content.industries.img4})`,
                          }}
                        >
                          <h3>{product.content.industries.title4}</h3>
                        </div>
                      </div>
                    </div>

                    <div className="row">
                      <div className="col-sm-6">
                        <div
                          className="inds_4"
                          style={{
                            backgroundImage: `url(${product.content.industries.img5})`,
                          }}
                        >
                          <h3>{product.content.industries.title5}</h3>
                        </div>
                      </div>
                      <div className="col-sm-6">
                        <div
                          className="inds_4"
                          style={{
                            backgroundImage: `url(${product.content.industries.img6})`,
                          }}
                        >
                          <h3>{product.content.industries.title6}</h3>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="col-sm-5">
                    <div
                      className="inds_1 "
                      style={{
                        backgroundImage: `url(${product.content.industries.img7})`,
                      }}
                    >
                      <h3>{product.content.industries.title7}</h3>
                    </div>
                    <div
                      className="inds_1 brmbr"
                      style={{
                        backgroundImage: `url(${product.content.industries.img8})`,
                      }}
                    >
                      <h3>{product.content.industries.title8}</h3>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>
        </>
      )}

      {slug === "hospitality-resorts" && (
        <>
          <section className="brands_section industries_we_dress">
            <div className="brands_content pro_content">
              <h2>{product.content.industries.heading}</h2>
              <p>{product.content.industries.text}</p>
            </div>
            <div className="industries_we_dress_with_purpose">
              <div className="container">
                <div className="row ">
                  <div className="col-sm-7">
                    <div className="row first_row">
                      <div className="col-sm-6">
                        <div
                          className="inds_3"
                          style={{
                            backgroundImage: `url(${product.content.industries.img1})`,
                          }}
                        >
                          <h3>{product.content.industries.title1}</h3>
                        </div>
                      </div>
                      <div className="col-sm-6">
                        <div
                          className="inds_3"
                          style={{
                            backgroundImage: `url(${product.content.industries.img2})`,
                          }}
                        >
                          <h3>{product.content.industries.title2}</h3>
                        </div>
                      </div>
                    </div>
                    <div className="row">
                      <div className="col-sm-6">
                        <div
                          className="inds_3"
                          style={{
                            backgroundImage: `url(${product.content.industries.img3})`,
                          }}
                        >
                          <h3>{product.content.industries.title3}</h3>
                        </div>
                      </div>
                      <div className="col-sm-6">
                        <div
                          className="inds_3"
                          style={{
                            backgroundImage: `url(${product.content.industries.img4})`,
                          }}
                        >
                          <h3>{product.content.industries.title4}</h3>
                        </div>
                      </div>
                    </div>
                    <div className="row">
                      <div className="col-sm-12">
                        <div
                          className="inds_4"
                          style={{
                            backgroundImage: `url(${product.content.industries.img5})`,
                          }}
                        >
                          <h3>{product.content.industries.title5}</h3>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="col-sm-5">
                    <div
                      className="inds_1"
                      style={{
                        backgroundImage: `url(${product.content.industries.img6})`,
                      }}
                    >
                      <h3>{product.content.industries.title6}</h3>
                    </div>
                    <div
                      className="inds_1 brmbr"
                      style={{
                        backgroundImage: `url(${product.content.industries.img7})`,
                      }}
                    >
                      <h3>{product.content.industries.title7}</h3>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>
        </>
      )}
      {slug === "government-police-defense" && (
        <>
          <section className="brands_section industries_we_dress">
            <div className="brands_content pro_content">
              <h2>{product.content.industries.heading}</h2>
              <p>{product.content.industries.text}</p>
            </div>
            <div className="industries_we_dress_with_purpose">
              <div className="container">
                <div className="row ">
                  <div className="col-sm-5">
                    <div
                      className="inds_1"
                      style={{
                        backgroundImage: `url(${product.content.industries.img1})`,
                      }}
                    >
                      <h3>{product.content.industries.title1}</h3>
                    </div>
                    <div
                      className="inds_1 brmbr"
                      style={{
                        backgroundImage: `url(${product.content.industries.img2})`,
                      }}
                    >
                      <h3>{product.content.industries.title2}</h3>
                    </div>
                  </div>
                  <div className="col-sm-7">
                    <div className="row first_row">
                      <div className="col-sm-6">
                        <div
                          className="inds_3"
                          style={{
                            backgroundImage: `url(${product.content.industries.img3})`,
                          }}
                        >
                          <h3>{product.content.industries.title3}</h3>
                        </div>
                      </div>
                      <div className="col-sm-6">
                        <div
                          className="inds_3"
                          style={{
                            backgroundImage: `url(${product.content.industries.img4})`,
                          }}
                        >
                          <h3>{product.content.industries.title4}</h3>
                        </div>
                      </div>
                    </div>

                    <div className="row">
                      <div className="col-sm-12">
                        <div
                          className="inds_5"
                          style={{
                            backgroundImage: `url(${product.content.industries.img5})`,
                          }}
                        >
                          <h3>{product.content.industries.title5}</h3>
                        </div>
                      </div>
                    </div>
                    <div className="row">
                      <div className="col-sm-12">
                        <div
                          className="inds_5"
                          style={{
                            backgroundImage: `url(${product.content.industries.img6})`,
                          }}
                        >
                          <h3>{product.content.industries.title6}</h3>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>
        </>
      )}
      {slug === "pilot-uniforms-aviation" && (
        <>
          <section className="brands_section industries_we_dress">
            <div className="brands_content pro_content">
              <h2>{product.content.industries.heading}</h2>
              <p>{product.content.industries.text}</p>
            </div>
            <div className="industries_we_dress_with_purpose">
              <div className="container">
                <div className="row ">
                  <div className="col-sm-5">
                    <div
                      className="inds_1"
                      style={{
                        backgroundImage: `url(${product.content.industries.img1})`,
                      }}
                    >
                      <h3>{product.content.industries.title1}</h3>
                    </div>
                    <div
                      className="inds_1 brmbr"
                      style={{
                        backgroundImage: `url(${product.content.industries.img2})`,
                      }}
                    >
                      <h3>{product.content.industries.title2}</h3>
                    </div>
                  </div>
                  <div className="col-sm-7">
                    <div className="row first_row">
                      <div className="col-sm-6">
                        <div
                          className="inds_3"
                          style={{
                            backgroundImage: `url(${product.content.industries.img3})`,
                          }}
                        >
                          <h3>{product.content.industries.title3}</h3>
                        </div>
                      </div>
                      <div className="col-sm-6">
                        <div
                          className="inds_3"
                          style={{
                            backgroundImage: `url(${product.content.industries.img4})`,
                          }}
                        >
                          <h3>{product.content.industries.title4}</h3>
                        </div>
                      </div>
                    </div>

                    <div className="row">
                      <div className="col-sm-12">
                        <div
                          className="inds_5"
                          style={{
                            backgroundImage: `url(${product.content.industries.img5})`,
                          }}
                        >
                          <h3>{product.content.industries.title5}</h3>
                        </div>
                      </div>
                    </div>
                    <div className="row">
                      <div className="col-sm-12">
                        <div
                          className="inds_5"
                          style={{
                            backgroundImage: `url(${product.content.industries.img6})`,
                          }}
                        >
                          <h3>{product.content.industries.title6}</h3>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>
        </>
      )}
      {slug === "healthcare-clinics-wellness" && (
        <>
          <section className="brands_section industries_we_dress">
            <div className="brands_content pro_content">
              <h2>{product.content.industries.heading}</h2>
              <p>{product.content.industries.text}</p>
            </div>
            <div className="industries_we_dress_with_purpose">
              <div className="container">
                <div className="row ">
                  <div className="col-sm-5">
                    <div
                      className="inds_1"
                      style={{
                        backgroundImage: `url(${product.content.industries.img1})`,
                      }}
                    >
                      <h3>{product.content.industries.title1}</h3>
                    </div>
                    <div
                      className="inds_1 brmbr"
                      style={{
                        backgroundImage: `url(${product.content.industries.img2})`,
                      }}
                    >
                      <h3>{product.content.industries.title2}</h3>
                    </div>
                  </div>
                  <div className="col-sm-7">
                    <div className="row first_row">
                      <div className="col-sm-6">
                        <div
                          className="inds_3"
                          style={{
                            backgroundImage: `url(${product.content.industries.img3})`,
                          }}
                        >
                          <h3>{product.content.industries.title3}</h3>
                        </div>
                      </div>
                      <div className="col-sm-6">
                        <div
                          className="inds_3"
                          style={{
                            backgroundImage: `url(${product.content.industries.img4})`,
                          }}
                        >
                          <h3>{product.content.industries.title4}</h3>
                        </div>
                      </div>
                    </div>

                    <div className="row">
                      <div className="col-sm-12">
                        <div
                          className="inds_5"
                          style={{
                            backgroundImage: `url(${product.content.industries.img5})`,
                          }}
                        >
                          <h3>{product.content.industries.title5}</h3>
                        </div>
                      </div>
                    </div>
                    <div className="row">
                      <div className="col-sm-12">
                        <div
                          className="inds_5"
                          style={{
                            backgroundImage: `url(${product.content.industries.img6})`,
                          }}
                        >
                          <h3>{product.content.industries.title6}</h3>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>
        </>
      )}
      {slug === "retail-brand-spaces" && (
        <>
          <section className="brands_section industries_we_dress">
            <div className="brands_content pro_content">
              <h2>{product.content.industries.heading}</h2>
              <p>{product.content.industries.text}</p>
            </div>
            <div className="industries_we_dress_with_purpose">
              <div className="container">
                <div className="row ">
                  <div className="col-sm-5">
                    <div
                      className="inds_1"
                      style={{
                        backgroundImage: `url(${product.content.industries.img1})`,
                      }}
                    >
                      <h3>{product.content.industries.title1}</h3>
                    </div>
                    <div
                      className="inds_1 brmbr"
                      style={{
                        backgroundImage: `url(${product.content.industries.img2})`,
                      }}
                    >
                      <h3>{product.content.industries.title2}</h3>
                    </div>
                  </div>
                  <div className="col-sm-7">
                    <div className="row first_row">
                      <div className="col-sm-6">
                        <div
                          className="inds_3"
                          style={{
                            backgroundImage: `url(${product.content.industries.img3})`,
                          }}
                        >
                          <h3>{product.content.industries.title3}</h3>
                        </div>
                      </div>
                      <div className="col-sm-6">
                        <div
                          className="inds_3"
                          style={{
                            backgroundImage: `url(${product.content.industries.img4})`,
                          }}
                        >
                          <h3>{product.content.industries.title4}</h3>
                        </div>
                      </div>
                    </div>

                    <div className="row">
                      <div className="col-sm-12">
                        <div
                          className="inds_5"
                          style={{
                            backgroundImage: `url(${product.content.industries.img5})`,
                          }}
                        >
                          <h3>{product.content.industries.title5}</h3>
                        </div>
                      </div>
                    </div>
                    <div className="row">
                      <div className="col-sm-12">
                        <div
                          className="inds_5"
                          style={{
                            backgroundImage: `url(${product.content.industries.img6})`,
                          }}
                        >
                          <h3>{product.content.industries.title6}</h3>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>
        </>
      )}
      {slug === "educational-institutions" && (
        <>
          <section className="brands_section industries_we_dress">
            <div className="brands_content pro_content">
              <h2>{product.content.industries.heading}</h2>
              <p>{product.content.industries.text}</p>
            </div>
            <div className="industries_we_dress_with_purpose">
              <div className="container">
                <div className="row ">
                  <div className="col-sm-3">
                    <div
                      className="edu_1"
                      style={{
                        backgroundImage: `url(${product.content.industries.img1})`,
                      }}
                    >
                      <h3>{product.content.industries.title1}</h3>
                    </div>
                    <div
                      className="edu_1"
                      style={{
                        backgroundImage: `url(${product.content.industries.img2})`,
                      }}
                    >
                      <h3>{product.content.industries.title2}</h3>
                    </div>
                  </div>
                  <div className="col-sm-6">
                    <div
                      className="edu_2"
                      style={{
                        backgroundImage: `url(${product.content.industries.img3})`,
                      }}
                    >
                      <h3>{product.content.industries.title3}</h3>
                    </div>
                  </div>
                  <div className="col-sm-3">
                    <div
                      className="edu_1"
                      style={{
                        backgroundImage: `url(${product.content.industries.img4})`,
                      }}
                    >
                      <h3>{product.content.industries.title4}</h3>
                    </div>
                    <div
                      className="edu_1"
                      style={{
                        backgroundImage: `url(${product.content.industries.img5})`,
                      }}
                    >
                      <h3>{product.content.industries.title5}</h3>
                    </div>
                  </div>
                </div>
                <div className="row ">
                  <div className="col-sm-5">
                    <div
                      className="edu_3"
                      style={{
                        backgroundImage: `url(${product.content.industries.img6})`,
                      }}
                    >
                      <h3>{product.content.industries.title6}</h3>
                    </div>
                  </div>
                   <div className="col-sm-7">
                    <div
                      className="edu_3"
                      style={{
                        backgroundImage: `url(${product.content.industries.img7})`,
                      }}
                    >
                      <h3>{product.content.industries.title7}</h3>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>
        </>
      )}

     

      {/* Process Section */}
      <section className="our_process_section design_process">
        <div className="container">
          <div className="row">
            <div className="brands_content process_content internal_process ">
              <h2>{product.content.process.heading}</h2>
              <p
                dangerouslySetInnerHTML={{
                  __html: product.content.process.text,
                }}
              ></p>
            </div>
            <div className="process_content_img">
              <div className="process_content_img_1">
                <img
                  src={product.content.process.img1}
                  alt=""
                  className="logom heightimgpro"
                />
                <h3>{product.content.process.title1}</h3>
              </div>
              <div className="process_content_img_1">
                <img
                  src={product.content.process.img8}
                  alt=""
                  className="logomm"
                />
              </div>
              <div className="process_content_img_1">
                <img
                  src={product.content.process.img2}
                  alt=""
                  className="logom heightimgpro"
                />
                <h3>{product.content.process.title2}</h3>
              </div>
              <div className="process_content_img_1">
                <img
                  src={product.content.process.img9}
                  alt=""
                  className="logomm"
                />
              </div>
              <div className="process_content_img_1">
                <img
                  src={product.content.process.img3}
                  alt=""
                  className="logom heightimgpro"
                />
                <h3>{product.content.process.title3}</h3>
              </div>
              <div className="process_content_img_1">
                <img
                  src={product.content.process.img10}
                  alt=""
                  className="logomm"
                />
              </div>
              <div className="process_content_img_1">
                <img
                  src={product.content.process.img4}
                  alt=""
                  className="logom heightimgpro"
                />
                <h3>{product.content.process.title4}</h3>
              </div>
              <div className="process_content_img_2">
                {/* <h2>{product.content.process.title8}</h2> */}
                <h2
                  dangerouslySetInnerHTML={{
                    __html: product.content.process.title8,
                  }}
                ></h2>
                <div data-animate="bottom" className="animeslide-des">
                  <a href="#" data-bs-toggle="modal" data-bs-target="#staticBackdrop"><span>{product.content.process.btntext}</span></a>
                </div>
              </div>
              <div className="process_content_img_1 "></div>
              <div className="process_content_img_1">
                <img
                  src={product.content.process.img7}
                  alt=""
                  className="logom heightimgpro"
                />
                <h3>{product.content.process.title7}</h3>
              </div>
              <div className="process_content_img_1">
                <img
                  src={product.content.process.img11}
                  alt=""
                  className="logomm"
                />
                <h3></h3>
              </div>
              <div className="process_content_img_1">
                <img
                  src={product.content.process.img6}
                  alt=""
                  className="logom heightimgpro"
                />
                <h3>{product.content.process.title6}</h3>
              </div>

              <div className="process_content_img_1">
                <img
                  src={product.content.process.img12}
                  alt=""
                  className="logomm"
                />
              </div>

              <div className="process_content_img_1">
                <img
                  src={product.content.process.img5}
                  alt=""
                  className="logom heightimgpro"
                />
                <h3>{product.content.process.title5}</h3>
              </div>

              <div className="process_content_img_1">
                <img
                  src={product.content.process.img13}
                  alt=""
                  className="process_img"
                />
              </div>
              <div className="process_content_img_2 mobile">
                <h2>{product.content.process.title8}</h2>
                <div data-animate="bottom" className="animeslide-des">
                  <a href="#" data-bs-toggle="modal" data-bs-target="#staticBackdrop"><span>{product.content.process.btntext}</span></a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Get In Touch Section */}
      <section
        className="get_in_touch_section"
        style={{ backgroundImage: `url(${product.content.getintuch.img2})` }}
      >
        <div className="container">
          <div className="row get_in_touch">
            <div className="col-sm-5 get_in_touch_left">
              <div className="get_in_touch_lefts">
                <div className="brands_content get_content">
                  <h2>{product.content.getintuch.heading}</h2>
                  <p>{product.content.getintuch.text}</p>
                </div>
                <img
                  src={product.content.getintuch.img1}
                  alt=""
                  className="get_in_touch"
                />
              </div>
            </div>
            <div className="col-sm-6">
              <div className="get_in_touch_right">
                <ContactForm />
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Services Section */}
      <section className="brands_section industries_we_dress proudct_tab servi_bran">
        <div className="industries_we_dress_with_purpose proudct_tab_content">
          <div className="container">
            <div className="row">
              <div className="brands_content industries_content pro_content merchandising">
                <h2>Merchandising & Add-On Services</h2>
                <p>
                  Each sector is unique. So is the uniform we design for it.
                </p>
              </div>
              {product.content.services.map((s, idx) => (
                <div key={idx} className="col-sm-4">
                  <div
                    className="inds_1 brmbr"
                    style={{ backgroundImage: `url(${s.img})` }}
                  >
                    <h3>{s.title}</h3>
                    <p>{s.text}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>

      {/* Clients Section */}
      <section
        className="brands_section client"
        style={{ backgroundImage: `url(${product.content.brands.img})` }}
      >
        <div className="container">
          <div className="brands_content">
            <h2>Trusted by Businesses Across Diverse Industries</h2>
            <p>
              From renowned luxury hotels to quick service restaurants and
              airlines, industry <br></br>leaders trust us with their uniform
              needs
            </p>
          </div>
          <div className="brands_logo">
            {product.content.clients.map((logo, idx) => (
              <img key={idx} src={logo} alt={`client-${idx}`} />
            ))}
          </div>
        </div>
      </section>

      {/* SKETCH */}
      <section className="our_process_section design_process">
        <div className="container">
          <div className="row">
            <div className="brands_content process_contents ">
              <h2>{product.content.processsketch.heading}</h2>
              <p>{product.content.processsketch.text}</p>
            </div>
            <div className="process_content_img">
              <div className="process_content_img_1">
                <img
                  src={product.content.processsketch.img1}
                  alt=""
                  className="logom heightimg"
                />
                <h3>{product.content.processsketch.title1}</h3>
              </div>
              <div className="process_content_img_1">
                <img
                  src={product.content.processsketch.img8}
                  alt=""
                  className="logomm"
                />
              </div>
              <div className="process_content_img_1">
                <img
                  src={product.content.processsketch.img2}
                  alt=""
                  className="logom heightimg"
                />
                <h3>{product.content.processsketch.title2}</h3>
              </div>
              <div className="process_content_img_1">
                <img
                  src={product.content.processsketch.img9}
                  alt=""
                  className="logomm"
                />
              </div>
              <div className="process_content_img_1">
                <img
                  src={product.content.processsketch.img3}
                  alt=""
                  className="logom heightimg"
                />
                <h3>{product.content.processsketch.title3}</h3>
              </div>
              <div className="process_content_img_1">
                <img
                  src={product.content.processsketch.img10}
                  alt=""
                  className="logomm"
                />
                <h3></h3>
              </div>
              <div className="process_content_img_1">
                <img
                  src={product.content.processsketch.img4}
                  alt=""
                  className="logom heightimg"
                />
                <h3>{product.content.processsketch.title4}</h3>
              </div>
              <div className="process_content_img_2">
                <h2>
                  Share Your Vision. We’ll<br></br> Bring It to Life
                </h2>
                <div data-animate="bottom" className="animeslide-des">
                  <a href="#" data-bs-toggle="modal" data-bs-target="#staticBackdrop"><span>Get In Touch</span></a>
                </div>
              </div>
              <div className="process_content_img_1 "></div>
              <div className="process_content_img_1">
                <img
                  src={product.content.processsketch.img5}
                  alt=""
                  className="logom heightimg"
                />
                <h3>{product.content.processsketch.title5}</h3>
              </div>
              <div className="process_content_img_1">
                <img
                  src={product.content.processsketch.img11}
                  alt=""
                  className="logomm"
                />
                <h3></h3>
              </div>
              <div className="process_content_img_1">
                <img
                  src={product.content.processsketch.img6}
                  alt=""
                  className="logom heightimg"
                />
                <h3>{product.content.processsketch.title6}</h3>
              </div>

              <div className="process_content_img_1">
                <img
                  src={product.content.processsketch.img12}
                  alt=""
                  className="logomm"
                />
              </div>

              <div className="process_content_img_1">
                <img
                  src={product.content.processsketch.img7}
                  alt=""
                  className="logom heightimg"
                />
                <h3>{product.content.processsketch.title7}</h3>
              </div>

              <div className="process_content_img_1">
                <img
                  src={product.content.processsketch.img8}
                  alt=""
                  className="process_img"
                />
              </div>
              <div className="process_content_img_2 mobile">
                <h2>
                  Share Your Vision. We’ll<br></br> Bring It to Life
                </h2>
                <div data-animate="bottom" className="animeslide-des">
                  <a href="#" data-bs-toggle="modal" data-bs-target="#staticBackdrop"><span>Get In Touch</span></a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Testimonials */}
     
      <CustomerSay />



{/* FAQ Section Start */}
{product.content.faq && (
  <section className="py-5 bg-light">
    <div className="container">

      <div className="text-center mb-5">
        <h2 className="fw-bold">Frequently Asked Questions</h2>
      </div>

      <div className="accordion" id="productFaqAccordion">

        {product.content.faq.map((item, index) => (
          <div
            className="accordion-item border-0 mb-3 shadow-sm rounded-3"
            key={index}
          >
            <h2 className="accordion-header">
              <button
                className="accordion-button collapsed fw-semibold"
                type="button"
                data-bs-toggle="collapse"
                data-bs-target={`#faq${index}`}
              >
                {item.question}
              </button>
            </h2>

            <div
              id={`faq${index}`}
              className="accordion-collapse collapse"
              data-bs-parent="#productFaqAccordion"
            >
              <div className="accordion-body text-secondary">
                {item.answer}
              </div>
            </div>
          </div>
        ))}

      </div>
    </div>
  </section>
)}
{/* FAQ Section End */}

    </>
  );
};

export default ProductInternal;
